import React from "react";

import styles from "./Company.module.scss";

const Company: React.FC = () => {
  return (
    <section className={styles.company}>
      <div className="container">
        <h2 className={styles.title}>Компания Тканополис</h2>
        <div className={styles.body}>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/01.svg" alt="svg" />
            </div>
            <p className={styles.description}>Масштабы</p>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/02.svg" alt="svg" />
            </div>
            <p className={styles.description}>Уникальный дизайн</p>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/03.svg" alt="svg" />
            </div>
            <p className={styles.description}>Производство</p>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/04.svg" alt="svg" />
            </div>
            <p className={styles.description}>Эксклюзивные ткани</p>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/05.svg" alt="svg" />
            </div>
            <p className={styles.description}>Гарантии</p>
          </div>
          <div className={styles.item}>
            <div className={styles.icon}>
              <img src="/img/main/company/06.svg" alt="svg" />
            </div>
            <p className={styles.description}>Качество</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Company;
